<template>
  <div class="pageview" style="padding: 10px; background-color: #f8f9fa; min-height: 100vh;">
    <!-- 搜索区域 -->
    <div class="search-box" style="background-color: #fff; padding: 16px; border-radius: 12px; box-shadow: 0 1px 6px rgba(0,0,0,0.1); margin-bottom: 16px;">
      <van-field
        v-model="queryParams.type"
        label="类型"
        placeholder="请输入类型"
        clearable
        @keyup.enter="handleQuery"
        style="margin-bottom: 12px;border:1px solid #eee;"
      />
      <div style="display: flex; gap: 10px;">
        <van-button type="info" size="small" block icon="search" @click="handleQuery">搜索</van-button>
        <van-button size="small" block icon="replay" @click="resetQuery">重置</van-button>
      </div>
    </div>

    <!-- 新增按钮 -->
    <div style="padding: 0 10px 16px;">
      <van-button
        type="primary"
        size="small"
        icon="plus"
        block
        @click="$refs.addImageType.addCreateForm(platForm)"
      >
        新增类型
      </van-button>
    </div>

    <!-- 数据列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoadMore"
      style="padding: 0 10px;"
    >
      <van-cell-group inset v-for="(item, index) in dataList" :key="item.id || index" style="margin-bottom: 12px;">
        <van-cell title="类型" :value="item.type" />
        <van-cell title="" style="text-align: right;">
          <template #default>
            <van-button size="mini" type="primary" plain @click="$refs.addImageType.showCreateForm(item)">编辑</van-button>
            <van-button size="mini" type="danger" plain style="margin-left: 8px;" @click="handleDelete(item)">
              删除
            </van-button>
          </template>
        </van-cell>
      </van-cell-group>
    </van-list>

    <!-- 分页由 list 自动控制，无需单独 pagination -->

    <!-- 弹窗组件（仍保留原 addImageType，仅样式变化） -->
    <addImageTypeVant ref="addImageType" @ok="getList" />
  </div>
</template>

<script>
import { imageTypeList, imageTypeDel } from "@/api/imageType";
import addImageTypeVant from "@/views/system/imageType/addImageTypeVant";

export default {
  components: {
    addImageTypeVant,
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        platForm: "",
        type: null,
      },
      loading: false,
      total: 0,
      dataList: [],
      finished: false,
      showSearch: true,
      platForm: "",
      userId: "",
      userName: "",
      oriApi: "",
    };
  },
  mounted() {
    this.userId = this.$route.query.userId;
    this.userName = this.$route.query.userName;
    this.platForm = this.$route.query.platForm;
    this.oriApi = this.$route.query.oriApi;
    this.queryParams.platForm = this.$route.query.platForm;
    this.getList();
  },
  methods: {
    // 获取数据列表
    getList() {
      this.loading = true;
      imageTypeList(this.queryParams).then((response) => {
        const result = response.data.data;
        this.dataList = result.list || [];
        this.total = result.total;
        this.loading = false;
        this.finished = this.dataList.length >= this.total;
      }).catch(() => {
        this.loading = false;
      });
    },

    // 下拉加载更多（兼容分页）
    onLoadMore() {
      if (this.dataList.length >= this.total) {
        this.finished = true;
        return;
      }
      this.queryParams.pageNum += 1;
      imageTypeList(this.queryParams).then((response) => {
        const result = response.data.data;
        this.dataList.push(...(result.list || []));
        this.total = result.total;
        this.loading = false;
        if (this.dataList.length >= this.total) {
          this.finished = true;
        }
      }).catch(() => {
        this.loading = false;
      });
    },

    handleDelete(row) {
      this.$dialog.confirm({
        title: '确认删除',
        message: `是否确认删除编号为 "${row.id}" 的数据项？`,
      })
        .then(() => {
          return imageTypeDel({ id: row.id });
        })
        .then(() => {
          this.$toast.success("删除成功");
          this.getList();
        })
        .catch(() => {});
    },

    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        platForm: this.platForm,
        type: null,
      };
      this.handleQuery();
    },
  },
};
</script>

<style scoped>
.pageview {
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 标题文字加粗 */
.van-cell__title {
  font-weight: 600;
  color: #333;
}

/* 操作按钮紧凑排布 */
.van-button--mini {
  padding: 0 8px;
  height: 28px;
  font-size: 12px;
}

/* 卡片圆角与阴影 */
.van-cell-group--inset {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
</style>